export interface OfflineProductFilterOptions {
  category?: number;
  stock?: number;
  size?: number;
}

interface OfflineProductFilterable {
  category?: number;
  stock?: number;
  code?: string;
  vin?: string;
  description?: string;
  lot?: string;
  colorDescription?: string;
}

export const filterOfflineProducts = <T extends OfflineProductFilterable>(
  products: T[],
  search: string,
  options: OfflineProductFilterOptions = {}
): T[] => {
  const term = search.trim().toLocaleLowerCase('es');
  const size = options.size ?? 50;

  return products
    .filter((product) => {
      if (
        options.category !== undefined &&
        options.category !== 0 &&
        product.category !== options.category
      ) {
        return false;
      }
      if (options.stock !== undefined && Number(product.stock ?? 0) < options.stock) return false;
      if (!term) return true;

      const haystack = [
        product.code,
        product.vin,
        product.description,
        product.lot,
        product.colorDescription,
      ]
        .filter(Boolean)
        .join(' ')
        .toLocaleLowerCase('es');
      return haystack.includes(term);
    })
    .slice(0, size);
};
